import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";
import { CsvDiffAPI } from "../../Services/APIService";
import { csv } from "../../Services/Tools";

function CSVDifference() {
    const navigate = useNavigate();
    const location = useLocation();

    const [baseCsv, setBaseCsv] = useState("");
    const [inputs, setInputs] = useState([""]);

    const toolFav = { toolName: "CSV Diff", Iconpath: "/GitDiffRaw.svg" };

    

    useEffect(() => {
        if (location.state?.baseCsv && location.state?.inputs) {
            setBaseCsv(location.state.baseCsv);
            setInputs(location.state.inputs);
        }
    }, [location.state]);


    

    const addInput = () => {
        if (inputs.length >= 3) return;
        setInputs([...inputs, ""]);
    };

    const removeInput = (index) => {
        if (inputs.length === 1) return; // prevent removing last one
        const updated = inputs.filter((_, i) => i !== index);
        setInputs(updated);
    };

    const updateInput = (index, value) => {
        const updated = [...inputs];
        updated[index] = value;
        setInputs(updated);
    };


    const pasteExample = (type, index) => {
        const example = csv;
        if (type === "base") setBaseCsv(example);
        else updateInput(index, example);
    };

    const computeDiff = async () => {
        if (!baseCsv.trim() || inputs.length === 0) return;

        try {
            const compareWith = inputs.filter(i => i !== "" && i.trim());
            const payload = {
                baseCsv: baseCsv,
                compareWith
            };
            const response = await CsvDiffAPI(payload);
            const apiData = response?.data;
            if (!apiData) return;

            navigate("/csv-diff-view", {
                state: {
                    baseCsv,
                    inputs,
                    validInputs: compareWith,
                    comparisons: apiData.comparisons || []
                }
            });
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Col className="json-multi-diff-page">
            {/* HEADER */}
            <ToolHeader title="CSV Diff" description="Compare a base CSV with multiple CSV inputs" toolFav={toolFav} />

            {/* BASE CSV */}
            <Row className="Formatter">
                <FormatterPanel
                    title="Base CSV"
                    value={baseCsv}
                    onChange={(e) => setBaseCsv(e.target.value)}
                    placeholder="Paste base CSV here..."
                    lineCount={baseCsv!== "" ?baseCsv.split("\n").length:0}
                    panelStyle={{ width: "100%", height: "250px" }}
                    headerButtons={
                        <InputHeaderButtons
                            primaryLabel="Example"
                            onPrimary={() => pasteExample("base")}
                            onClear={() => setBaseCsv("")}
                            onImport={(file) => setBaseCsv(file)}
                        />
                    }
                    footerLeft={`Characters : ${baseCsv.replaceAll(" ", "").length}`}
                    footerRight={`Size : ${new Blob([baseCsv]).size} B`}
                />
            </Row>

            {/* âœ… GRID INPUTS */}
            <Row
                className="multi-input-grid"
                style={{
                    gridTemplateColumns: `repeat(${inputs.length}, 1fr)`
                }}
            >
                {inputs.map((input, index) => (
                    <div key={index} className="grid-item">
                        <FormatterPanel
                            title={`CSV ${index + 1}`}
                            value={input}
                            onChange={(e) => updateInput(index, e.target.value)}
                            placeholder="Paste CSV here..."
                            lineCount={input!== "" ?input.split("\n").length:0}
                            panelStyle={{ height: "250px", width: "inherit" }}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={() => pasteExample("input", index)}
                                    onClear={() => updateInput(index, "")}
                                    onImport={(file) => updateInput(index, file)}
                                    accept=".csv"
                                    onRemove={() => removeInput(index)}
                                    showRemove={inputs.length > 1}
                                />
                            }
                            footerLeft={`Characters : ${input.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([input]).size} B`}
                        />
                    </div>
                ))}
            </Row>

            <Row>
            {inputs.length < 3 && <Col className="add-json-btn" onClick={addInput}>
                + Add CSV to compare
            </Col>}
            </Row>

            {/* BOTTOM BAR */}
            
            <Row className="bottom-bar">
                <Col>
                <span>
                    Comparing Base CSV with {inputs.filter(i => i.trim()).length} input{inputs.filter(i => i.trim()).length !== 1 ? "s" : ""}
                </span>
                </Col>
                <Col>
                <button className="compare-btn" onClick={computeDiff}>
                    Compare
                </button>
                </Col>
            </Row>
             
        </Col>
    );
}

export default CSVDifference;
